export default __webpack_public_path__ + "static/media/kitchen4-afterA-480w.d00d7985.webp";